var _mask, _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6451_11931",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 29,
    height: 33,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 29,
    height: 33,
    rx: 2,
    stroke: "#46B476",
    strokeWidth: 4.6,
    mask: "url(#path-1-inside-1_6451_11931)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 22.0352L9.50014 21.9632",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14258 13.0508H10.7627L11.9385 15.9287H12L13.1758 13.0508H14.7959V18H13.5244V15.0879H13.4834L12.3555 17.9658H11.5762L10.4551 15.0674H10.4141V18H9.14258V13.0508ZM15.4658 18V13.0508H19V14.1035H16.7646V14.999H18.8154V16.0518H16.7646V16.9473H18.9932V18H15.4658ZM23.9424 13.0508V18H22.8555L21.0166 15.3271H20.9824V18H19.6836V13.0508H20.791L22.6025 15.71H22.6436V13.0508H23.9424ZM27.5586 13.0508H28.8574V16.2295C28.8574 17.3506 28.0029 18.0615 26.7314 18.0615C25.46 18.0615 24.6123 17.3506 24.6123 16.2295V13.0508H25.9111V16.1133C25.9111 16.5918 26.2529 16.9336 26.7314 16.9336C27.2168 16.9336 27.5586 16.5918 27.5586 16.1133V13.0508Z",
    fill: "#46B476"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.09961L30 1.5V5.09961H9.5",
    stroke: "#46B476",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.93d3e0983b2ce7776ac342278ce0dc47.svg";
export { ForwardRef as ReactComponent };